import File from './File';
import FileViewer from './FileViewer';

class Protonfile {
  FileViewer: FileViewer;
  File: File;
  constructor() {
    this.FileViewer = new FileViewer();
    this.File = new File();
  }
}

declare global {
  interface Window {
    Protonfile: Protonfile;
  }
}

export default Protonfile;
